import script from "./UserMatriculesByCompany.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserMatriculesByCompany.vue?vue&type=script&lang=ts&setup=true"

import "./UserMatriculesByCompany.vue?vue&type=style&index=0&id=03774c7a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03774c7a"]])

export default __exports__